<template>
    <div class="">
        <br/>
        <div class="row page-row users">
            <div class="col-sm-8">

                <table class="table users">
                    <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">User</th>
                        <th scope="col">Role</th>
                        <th scope="col"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="user in users" v-bind:key="user.id">
                        <th scope="row">{{ user.unique_id }}</th>
                        <td>{{ user.name }}</td>
                        <td>{{ user.role.name }}</td>
                        <td>{{ $options.filters.moment(user.updated_at, 'DD.MM.YYYY HH:mm') }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Verte from 'verte';
    import 'verte/dist/verte.css';
    import '@css/users.css';
    import axios from "axios";

    Vue.component('verte', Verte);

    export default {
        comments: {Verte},
        data() {
            return {
                users: [],
                roles: [],
                projects: [],
            }
        },
        mounted() {
            this.load();
        },
        methods: {
            load() {
                this.loadUsers();
                this.loadRoles();
                this.loadProjects();
            },
            loadUsers() {
                if (!this.$store.state.project.id) {
                    return;
                }
                this.$store.dispatch('loadProjectUsers').then((users) => {
                    console.log('aaaa');
                    this.users = users;
                });
            },
            loadRoles() {
                if (!this.$store.state.project.id) {
                    return;
                }
                this.$store.dispatch('loadRoles').then((roles) => {
                    this.roles = roles;
                });
            },
            loadProjects() {
                let token = this.$store.state.token;

                axios({
                    url: this.$store.getters.apiBase + '/projects',
                    method: 'GET',
                    headers: {"Authorization": "Bearer " + token}
                })
                    .then(response => {
                        this.projects = response.data.data;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            showCreateUserModal() {
                this.createUserStep = 1;
                this.resetCurrentUser();

                this.$bvModal.show('create-user-modal');

            },
            confirmDeleteUser(user) {
                this.currentUser = {...user};

                this.$bvModal.show('remove-user-modal');
            },
            deleteUser() {

                const token = this.$store.state.token;

                axios({
                    url: this.$store.getters.apiBase + '/users/' + this.currentUser.id,
                    method: 'DELETE',
                    headers: {"Authorization": "Bearer " + token}
                })
                    .then(response => {
                        this.$bvModal.hide('remove-user-modal');
                        this.load();
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            editUser(user) {
                this.createUserStep = 1;
                this.currentUser = {...user};
                this.currentUser.password = null;
                this.currentUser.confirm_password = null;

                this.$bvModal.show('create-user-modal');


                // this.$refs.createUserButton.click();
            },
            resetCurrentUser() {
                this.currentUser = {
                    id: null,
                    name: null,
                    email: null,
                    unique_id: null,
                    color: "#dc3545",
                    password: null,
                    confirm_password: null,
                    role: {
                        id: null,
                        name: null
                    },
                    assigned_projects: []
                };
                this.createUserStep = 1;

            },
            projectChange(event, project) {
                if (event.target.checked) {
                    this.currentUser.assigned_projects.push(project);
                } else {
                    this.currentUser.assigned_projects = this.currentUser.assigned_projects.filter(function (obj) {
                        return obj.id !== project.id;
                    });
                }
            },
            saveUser(event) {
                event.preventDefault();

                this.errors = [];

                if (!this.currentUser.name) {
                    this.errors.push("Name required.");
                }

                if (!this.currentUser.email) {
                    this.errors.push("Email  required.");
                } else if (!this.validEmail(this.currentUser.email)) {
                    this.errors.push('Valid email required.');
                }

                if (!this.currentUser.role.id) {
                    this.errors.push("Role required.");
                }

                if (!this.currentUser.id) {
                    if (!this.currentUser.password) {
                        this.errors.push("Password  required.");
                    }
                    if (!this.currentUser.confirm_password) {
                        this.errors.push("Password confirmation required.");
                    }
                }

                if (this.currentUser.password !== this.currentUser.confirm_password) {
                    this.errors.push("Passwords don't match.");
                }


                if (this.currentUser.password) {
                    const lowerCaseLetters = /[a-z]/g;
                    const upperCaseLetters = /[A-Z]/g;
                    const numbers = /[0-9]/g;

                    if (this.currentUser.password.length < 8 || !this.currentUser.password.match(lowerCaseLetters)
                        || !this.currentUser.password.match(upperCaseLetters) || !this.currentUser.password.match(numbers)) {
                        this.errors.push("The password must be at least 8 characters long, must contain both lower- and uppercase letters and numbers.");
                    }

                }


                if (!this.errors.length) {
                    const token = this.$store.state.token;

                    axios({
                        url: this.$store.getters.apiBase + '/users',
                        data: this.currentUser,
                        method: 'POST',
                        headers: {"Authorization": "Bearer " + token}
                    })
                        .then(response => {
                            this.$bvModal.hide('create-user-modal');
                            this.load();
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }

            },
            validEmail: function (email) {
                let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            }
        }
    }
</script>
